import type { FirestoreContainer } from './FirestoreContainer.js';

import { createContainer } from '@elara/core/di';

import { createClientItineraryItemModel } from '#models/ItineraryItemModel.js';

export function createItineraryContainer(firestore: FirestoreContainer) {
  const $itinerary = createContainer('itinerary').providedLazy('ClientItineraryItem', () =>
    createClientItineraryItemModel(firestore),
  );
  return $itinerary;
}

export type $ItineraryContainer = ReturnType<typeof createItineraryContainer>;
export type ItineraryContainer = $ItineraryContainer['use'];
